<template>
	<div class="col-md-12 search result">

		<vue-bootstrap4-table class="b4-table" :columns="columns" :rows="rows" :config="table.config" :classes="table.classes" @on-select-row="onselectrow">
			<template v-for="i in rowtemplates" :slot="i.slot" slot-scope="props">
				<span :key="i.slot" v-if="props.row[i.col]==i.value" :class="i.class">{{props.cell_value}}</span>
				<span :key="i.slot" v-else>{{props.cell_value}}</span>
			</template>
		</vue-bootstrap4-table>

		<div class="toolbox" v-if="rows.length && !noxls">
			<vue-excel-xlsx class="btn icon btn-light btn-secondary justify-content-center"
				:data="dataXLSX"
				:columns="columnXLSX"
				:file-name="reportname"
				:sheet-name="'Data'"
				>
				<i class="far fa-file-excel"></i>
			</vue-excel-xlsx>
		</div>

		<Loader v-if="loading" />

	</div>
</template>

<script>

import VueBootstrap4Table from 'vue-bootstrap4-table'
import { AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

import Vue from 'vue'
import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);

export default
{
	components: {
		VueBootstrap4Table,
		Loader
	},
	props:['reporturl', 'reportdata', 'reportname', 'rowtemplates', 'nopage', 'card_title', 'noxls', 'select_url', 'idcol', 'loading'],
	data() {
		return {
			table:
			{
				config: {
					pagination: !(this.nopage),
					pagination_info: true,
					per_page: 10,
					per_page_options: [10, 20, 50, 100],
					highlight_row_hover: true,
					card_mode: false,
					card_title: false,
					rows_selectable: true,
				},
				classes: {
					table: "table-striped"
				},
			},
			reportdata_:[],
		}
	},
	watch:{
		reporturl(now) {
			AxiosWithJar().get(now).then((response)=>{
				this.reportdata_ = response.data;
			})
		}
	},
	computed:{
		_reportdata() {
			return this.reportdata ? this.reportdata : this.reportdata_;
		},
		columns(){
			let cols=[];
			if (this._reportdata['columns']) {
				let columns = this._reportdata['columns'];
				for(var i=0; i<columns.length; i++){
					if (columns[i].format != 'hidden') {
						cols.push({
							label: columns[i].title,
							name: columns[i].field,
							sort: true,
							row_text_alignment: columns[i].format == 'number' || columns[i].format == 'percent' ? "text-right" : "text-left",
							column_text_alignment: "text-left",
							row_classes:"",
							column_classes:"",
						});
					}
				}
			}
			//console.log('cols: '+JSON.stringify(cols));
			return cols;
		},
		rows(){
			let rows=[];
			if (this._reportdata['columns']) {
				let columns = this._reportdata['columns'];
				let data = this._reportdata['data'];
				for	(var j=0; j<data.length; j++) {
					let row={}
					for (var i=0; i<columns.length; i++){
						let a = data[j][columns[i].field]
						if (columns[i].format == 'number') a = this.formatNum(a * 1);
						if (columns[i].format == 'percent') a = this.formatNum(a * 100) + "%";
						row[columns[i].field] = a
						//console.log('log: ' + a);
					}
					rows.push(row)
				}
			}
			return rows;
		},
		columnXLSX()
		{
			let labels=[];
			if (this._reportdata['columns']) {
				let columns = this._reportdata['columns'];
				for(var i=0; i<columns.length; i++){
					let dt = {}
					dt['field'] = columns[i].field;
					dt['label'] = columns[i].title;
					labels.push(dt);
				}
			}
			return labels;
		},
		dataXLSX(){
			let rows=[];
			if (this._reportdata['columns']) {
				rows = this._reportdata['data'];
			}
			return rows;
		},

	},
	mounted(){
		if (this.card_title) {
			this.table.config.card_mode = true;
			this.table.config.card_title = this.card_title;
		}
	},
	methods:{
		onselectrow(a) {
			if (this.idcol) {
				if(this.select_url) window.open(this.select_url + a.selected_item[this.idcol],'_blank')
			}
		},
	}
}
</script>
<style>

table.table{ font-size: 14px;}
table.table tr.vbt-table-tools{display: none;}
table.table th{ padding: 2px 10px !important;}
table.table .form-group{ margin-bottom: 0px;}


.search.result{ margin-top:10px; background:rgba(20,109,182,.0275); border-radius:5px 5px ; color:#666; padding:0px;   }
.search.result .toolbox {
    z-index: 99;
    position: fixed;
    bottom: 25px;
    right: 25px;
    display: flex; background: rgba(255,255,255,.75);
    border-radius: 25px;
}

    .search.result .toolbox button{ display: flex;
    font-size: 12px;
    align-items: center; background: rgba(20,109,182,.75) !important; color:#fff;
    border-radius: 15px; }
    .search.result .toolbox .btn.icon{ padding:15px; margin: 10px;}

.vbt-pagination-row {
	padding-left: 20px;
    padding-right: 20px;
    padding-top: 10px;
}

</style>
